
export const C_CLIENT_SEARCH = 11
export const C_RECOMMENDATION_VISIBLE = 4;


